module.exports = __webpack_public_path__ + "static/3A841E_4_0-e55fdbd7c9cbb6fbb4abf68ba5c1447a.woff";